import React from 'react';

const PageContent = () => {
  return (
    <div className="section-block background-gray normal-page">
      <div className="container">
        <div className="row">
          <div className="col-12 col-md-8">
            <h1 className="block-title">fsd</h1>
            <div className="post-content-text">
              <p>
                In Vietnam, international schools offer education from kindergarten to high school. Most of the
                international schools are located in suburban areas and they offer good services and facilities. The
                yearly fee increases as the grade goes up. In general, the yearly fee exceeds 15,000USD.
              </p>
              <p>
                Although curriculum differs from school to school, the quality of education is basically high and the
                English skills will be improved. It is needed that parents contact the international school in order to
                know the curriculum of the school. Most of school can be contacted in English.
              </p>

              <p>
                The school starts from September. Since there are many parents who consider having their children go to
                the international school, I would like you to know the basic information. The below is the general
                information on the major international schools in Hanoi.
              </p>

              <p>【Hanoi International School】</p>

              <p>
                Hanoi International School is located closed to Embassy of Japan in Lieu Giai. The total number of
                students is about 290. Japanese, Vietnamese, and Koreansaccount for the majority of the students. The
                yearly fee is from about 16,500USD to 26,500USD. The average number of students in a class is about 20.
              </p>
              <p>Website : https://www.hisvietnam.com/</p>
              <p>【United Nations International School of Hanoi】</p>
              <p>
                United Nations International School is owned by United Nations and it’s called UNIS. There are only 2
                international schools owned by United Nations and therefore. It is very popular. The location is Ciptra
                which is north of Ho Tay lake. There are about 1,100 students. As there is the limitation which the
                ratio of one nationality cannot exceed 20% of the total number of students, students from many different
                countries attend the school. The yearly fee is from about 24,500USD to 30,000USD.
              </p>

              <p>Website : https://www.unishanoi.org/</p>

              <p>【British Vietnamese international school Hanoi】</p>

              <p>
                British Vietnamese international school Hanoi is located inside Vincom Royal City in Thanh Xuan
                district. About 1,300 students attend the school and 90% of them are Vietnamese. The school offers
                education from kindergarten to high school. The class is taught in English and Vietnamese. The ratio of
                Students to teachers is about 12 to 1. The yearly fee is from about 15,000USD to 20,000USD.
              </p>

              <p>Web : https://www.nordangliaeducation.com/en/our-schools/vietnam/hanoi/bvis</p>

              <p>【British International School Hanoi】</p>

              <p>
                British International School Hanoi is located in Vinhomes Riverside in Long Bien district. This area is
                rich in nature and quiet compared to the urban area of Hanoi. There are about 1,000 students. 27
                nationals belong to the school and 50% of them are Vietnamese. The average number of students in a class
                is about 18. The school has a uniform. The class is from 8:30 to 15:00. There are many facilities such
                as a large library, auditorium. The yearly fee is from about 11,000USD to 15,500USD for kindergarten and
                from 20,000USD to 30,000USD for middle and high school.
              </p>

              <p>Web: https://www.nordangliaeducation.com/en/our-schools/vietnam/hanoi/bis</p>
            </div>
          </div>
          <div className="col-12 col-md-4">fsdf</div>
        </div>
      </div>
    </div>
  );
};

export default PageContent;
